import { useMemo } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { getQueryKeys } from '../queries/queryKeys';

const useHousingStockState = () => {
  const queryClient = useQueryClient();

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const housingStockQueryKey = useMemo(
    () => getQueryKeys.housingStock(currentCompany?.id),
    [currentCompany]
  );

  const housingStockState = queryClient.getQueryState(housingStockQueryKey);

  return { housingStockQueryKey, housingStockState };
};

export default useHousingStockState;
